// DEV-ONLY · FÜHRERSCHEIN-BÜHNE (Preview) — OPERATOR CORRECTION 30.09.2026.
// Verbindlich: Das vom Betreiber bereitgestellte, fotorealistische Führerschein-
// Hauptmotiv (fuehrerschein-hauptmotiv.webp, 1:1 aus dem freigegebenen ChatGPT-
// Bild) ist das FINALE HAUPTMOTIV — NICHT nachbauen, verändern, beschneiden,
// in einen Monitor/eine kleine Karte setzen oder in Bestandteile zerlegen.
// Es wird als EIN zusammenhängendes Asset groß & präsent gezeigt.
// Positionierung: NEU · ZUSATZMODUL.
// Bewusst OHNE zusätzliche Headline/Chris-Texte/Screenshots — erst sauber ins
// Bühnenbild setzen, danach entscheidet der Betreiber, ob mehr nötig ist.
// Live `/abo` bleibt UNBERÜHRT bis zur Sichtabnahme (STOP-GATE).
import { useEffect, useRef } from "react";
import "@/pages/abo/abo.css";

const SHOT = (n) => `/abo/screenshots/${n}`;
const OUTFIT =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap";

export default function AboFuehrerscheinDevPreview() {
  const ref = useRef(null);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = OUTFIT;
    document.head.appendChild(link);
    ref.current?.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
    return () => link.remove();
  }, []);

  return (
    <div
      className="abo-root"
      lang="de"
      ref={ref}
      data-testid="abo-fuehrerschein-dev"
      style={{ minHeight: "100vh" }}
    >
      <style>{`
        [data-testid="abo-fuehrerschein-dev"] .reveal{opacity:1 !important;transform:none !important;}
        [data-testid="abo-fuehrerschein-dev"] .dev-label{max-width:1200px;margin:0 auto;padding:22px 24px 0;font:600 .72rem/1.4 "Outfit",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#94a3b8;}

        /* Bühne · sehr helle Frozen-CI, subtiler Lichtverlauf, großzügiger Weißraum */
        [data-testid="abo-fuehrerschein-dev"] .fs-stage{background:radial-gradient(120% 120% at 50% -12%, #eef4fb 0%, #f5f7f9 48%, #eef4f2 100%);padding:64px 0 84px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-wrap{max-width:1200px;margin:0 auto;padding:0 24px;text-align:center;}

        /* Kennzeichnung ZUSATZMODUL (dezent, oberhalb) + Headline/Subline */
        [data-testid="abo-fuehrerschein-dev"] .fs-marks{display:inline-flex;align-items:center;gap:10px;margin:0 0 16px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-zusatz{font:600 .72rem/1 "Outfit",sans-serif;letter-spacing:.12em;text-transform:uppercase;color:#a2611a;background:#fdf1e2;border:1px solid #f4dcbf;border-radius:999px;padding:8px 14px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-head{max-width:880px;margin:0 auto 34px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-title{font-family:var(--font-display,"Outfit",sans-serif);font-weight:700;color:var(--ink);font-size:clamp(1.9rem,3.1vw,2.85rem);line-height:1.06;letter-spacing:-.01em;margin:0 0 12px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-sub{font:500 1.05rem/1.55 "Outfit",sans-serif;color:var(--body,#475569);margin:0;}

        /* Hauptmotiv · groß & präsent, als EIN Asset (kein Monitor, keine kleine Karte) */
        [data-testid="abo-fuehrerschein-dev"] .fs-hero{position:relative;margin:0 auto;max-width:1120px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-hero img{display:block;width:100%;height:auto;border-radius:22px;border:1px solid rgba(15,40,80,.06);box-shadow:0 40px 90px rgba(15,40,80,.20);}

        /* NEU · grüne diagonale Eck-Banderolen oben LINKS + RECHTS (kein Verlauf, keine Animation) */
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap{position:absolute;top:0;width:340px;height:340px;overflow:hidden;pointer-events:none;}
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap--right{right:0;border-top-right-radius:22px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap--left{left:0;border-top-left-radius:22px;}
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon{position:absolute;top:67px;width:455px;background:var(--green-deep,#0f6b4a);color:#fff;text-align:center;font:800 2rem/1 "Outfit",sans-serif;letter-spacing:.18em;text-transform:uppercase;padding:20px 0;box-shadow:0 10px 22px rgba(15,40,80,.30);}
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon--right{right:-115px;transform:rotate(45deg);}
        [data-testid="abo-fuehrerschein-dev"] .fs-ribbon--left{left:-115px;transform:rotate(-45deg);}

        @media(max-width:640px){
          [data-testid="abo-fuehrerschein-dev"] .fs-stage{padding:44px 0 60px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-wrap{padding:0 12px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-marks{margin-bottom:12px;flex-wrap:wrap;justify-content:center;}
          [data-testid="abo-fuehrerschein-dev"] .fs-head{margin-bottom:22px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-hero img{border-radius:16px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap{width:156px;height:156px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap--right{border-top-right-radius:16px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon-wrap--left{border-top-left-radius:16px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon{top:31px;width:210px;font-size:1.04rem;letter-spacing:.12em;padding:9px 0;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon--right{right:-60px;}
          [data-testid="abo-fuehrerschein-dev"] .fs-ribbon--left{left:-60px;}
        }
      `}</style>

      <div className="dev-label">Führerschein-Bühne · Preview · Hauptmotiv 1:1 · NEU · Zusatzmodul · Live /abo unberührt</div>

      <section className="fs-stage" data-testid="fs-stage">
        <div className="fs-wrap">
          <div className="fs-marks reveal">
            <span className="fs-zusatz" data-testid="fs-zusatz">Zusatzmodul</span>
          </div>
          <header className="fs-head reveal">
            <h2 className="fs-title" data-testid="fs-title">
              Führerscheinkontrolle ohne Listen, Ordner und Hinterherlaufen.
            </h2>
            <p className="fs-sub" data-testid="fs-sub">
              Mitarbeiter fotografiert. Sie prüfen. CLartext erinnert automatisch
              an die nächste Kontrolle.
            </p>
          </header>
          <figure className="fs-hero reveal" data-testid="fs-hero">
            <img
              src={SHOT("fuehrerschein-hauptmotiv.webp")}
              alt="CLartext Führerscheinkontrolle: Mitarbeiter fotografiert Vorder- und Rückseite des Führerscheins im Handy-Zugang, der Unternehmer prüft und gibt frei, CLartext dokumentiert und übernimmt die automatische Wiedervorlage."
              data-testid="fs-hero-img"
              width="1536"
              height="1024"
              loading="eager"
              draggable="false"
            />
            <span className="fs-ribbon-wrap fs-ribbon-wrap--left" aria-hidden="true">
              <span className="fs-ribbon fs-ribbon--left" data-testid="fs-neu-left">Neu</span>
            </span>
            <span className="fs-ribbon-wrap fs-ribbon-wrap--right" aria-hidden="true">
              <span className="fs-ribbon fs-ribbon--right" data-testid="fs-neu">Neu</span>
            </span>
          </figure>
        </div>
      </section>
    </div>
  );
}
